import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { QueryClientProvider } from '@tanstack/react-query'
import { queryClient } from '@/lib/query-client'
import { AppShell } from '@/components/shell/AppShell'
import { ProtectedRoute } from '@/components/auth/ProtectedRoute'
import { AuthBootstrap } from '@/features/auth/AuthBootstrap'
import { LoginPage } from '@/features/auth/pages/LoginPage'
import { ClassesPage } from '@/features/classes/pages/ClassesPage'
import { ClassDetailPage } from '@/features/classes/pages/ClassDetailPage'
import { TestSetsPage } from '@/features/test-sets/pages/TestSetsPage'
import { TestSetDetailPage } from '@/features/test-sets/pages/TestSetDetailPage'

function Placeholder({ title }: { title: string }) {
  return (
    <div className="flex flex-col gap-2">
      <h1 className="font-display text-2xl font-bold text-fg-1">{title}</h1>
      <p className="text-sm text-fg-3">Em breve.</p>
    </div>
  )
}

export function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <AuthBootstrap />
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            element={
              <ProtectedRoute>
                <AppShell />
              </ProtectedRoute>
            }
          >
            <Route path="/classes" element={<ClassesPage />} />
            <Route path="/classes/:id" element={<ClassDetailPage />} />
            <Route path="/benchmarks" element={<TestSetsPage />} />
            <Route path="/benchmarks/:id" element={<TestSetDetailPage />} />
            <Route path="/logs" element={<Placeholder title="Logs" />} />
            <Route path="/configuracoes" element={<Placeholder title="Configurações" />} />
          </Route>
          <Route path="*" element={<Navigate to="/classes" replace />} />
        </Routes>
      </BrowserRouter>
    </QueryClientProvider>
  )
}
